export function randomInt(max) {

	var realMax = 10000

	if(max != undefined){ realMax = max }

  	return Math.floor(Math.random() * realMax);
}

//console.log( cashFormat("1000.02", true) ); // Will print "$3,001"
export function cashFormat(value, addZeros) {
    // Check if the value is a number or text and convert it to a number
    var numericValue = isNaN(value) ? parseFloat(value.replace(/[^0-9.-]/g, '')) : parseFloat(value);

    // Check if the value is valid
    if (isNaN(numericValue)) {
        return "Invalid input. Please enter a number or a valid format.";
    }

    // Format the value as dollars
    var formattedValue = numericValue.toFixed(addZeros ? 2 : 0);
    formattedValue = "$" + formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return formattedValue;
}

function parsePercentInput(value) {
    if (value === null || value === undefined) return NaN;
    if (typeof value === 'number') return value;
    const s = String(value).trim().replace(/%/g, '').replace(',', '.');
    return parseFloat(s);
}

export function percentFormat(value, decimals = 2) {
    var numericValue = parsePercentInput(value);
    if (isNaN(numericValue)) return "0%";

    // UI cap: valores extremos desde BD (ej. 999.99) o ROI fuera de rango
    if (numericValue > 100) {
        return "+99.99%";
    }
    if (numericValue < -100) {
        return "-99.99%";
    }

    return numericValue.toFixed(decimals) + "%";
}

export function percentNumericForChart(value) {
    const numericValue = parsePercentInput(value);
    if (isNaN(numericValue)) return 0;
    if (numericValue > 100) return 99.99;
    if (numericValue < -100) return -99;
    return numericValue;
}